import { IAgentSchema } from 'shared/types/api-models/offer-card/v1/get-offer-data';

export function isDeveloperCanCallback(agent: IAgentSchema | null): boolean {
  return Boolean(
    agent && agent.isDeveloper && agent.availableServices && agent.availableServices.isPhoneChangingAvailable,
  );
}
